import axios, { AxiosInstance } from 'axios';

export const INBOUND_REQUEST_TIMEOUT_MS = 45000;
export const ZIM_REQUEST_TIMEOUT_MS = 20000;

export class PhishedClient {
  public api: AxiosInstance;

  public zimApi: AxiosInstance;

  public zimHealthApi: AxiosInstance;

  constructor(idToken?: string) {
    const authHeaders = idToken ? { Authorization: `Bearer ${idToken}` } : {};
    this.api = axios.create({
      baseURL: process.env.PHISHED_API_BASE_URL,
      headers: authHeaders,
      timeout: INBOUND_REQUEST_TIMEOUT_MS,
    });
    this.zimApi = axios.create({
      baseURL: `${process.env.ZIM_BASE_URL}/api`,
      headers: authHeaders,
      timeout: ZIM_REQUEST_TIMEOUT_MS,
    });
    this.zimHealthApi = axios.create({
      baseURL: process.env.ZIM_BASE_URL,
    });
  }
}
